import styled from 'styled-components';

interface IContentContainer {
  noPadding?: boolean;
}
export const ContentContainer = styled.div<IContentContainer>`
  padding: ${(props) => (props.noPadding ? '0' : '10px 20px')};
  width: 100%;
`;
interface IContainer {
  small?: boolean;
  redColor?: boolean;
}
export const Container = styled.div<IContainer>`
  height: 90px;
  width: 100%;
  border-radius: 16px;
  background: ${(props) => (props.redColor ? '#FDE3E3' : '#e2f3ea')};
  display: flex;
  align-items: center;
  justify-content: center;
  align-items: center;
  gap: 16px;
  border: 0.8px solid ${(props) => (props.redColor ? '#FDDEDE' : '#d1e1d9')};

  & svg {
    width: 30px;
    height: 30px;
    color: ${(props) => (props.redColor ? '#EF4343' : '#74c598')};
  }
`;
export const InfoText = styled.label<IContainer>`
  max-width: calc(100% - 80px);
  font-family: Roboto;
  font-weight: normal;
  font-size: ${(props) => (props.small ? '12px' : '14px')};
  color: ${(props) => (props.redColor ? '#EF4343' : '#74c598')};
`;
